import { Button } from '@polyseme/design-system';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import { images } from '~/landing/assets';

import { useScrollToContactCard } from './scroll-to-contact-card-context';

const SOURCE_URL =
  'https://fetch-pdf.platform.onclusive.org/?article_id=onclusive-fr-1240220356&application_id=content_delivery&locale=fr_fr&hash=eec2fc357864f8442886ba6df4a30e45425d882138deda07bc3264ffabb4585c&pdf_type=full&pdf_headers=false&full_page_link=false&media_type=print';

export const Hero = () => {
  const t = useTranslations('landing.retraite.hero');
  const scrollToContactCard = useScrollToContactCard();

  const footnote = t.rich('footnote', {
    br: () => <br />,
    link: (chunks) => (
      <a
        className="underline"
        href={SOURCE_URL}
        rel="noopener noreferrer"
        target="_blank"
      >
        {chunks}
      </a>
    ),
  });

  return (
    <>
      <section className="relative h-[400px] w-full overflow-hidden md:h-[600px]">
        <Image
          fill
          priority
          alt=""
          className="object-cover brightness-50"
          src={images.retraite.hero}
        />
        <div className="pointer-events-none absolute inset-0 z-20 grid place-items-center overflow-hidden">
          <div className="relative size-[300%] -translate-x-40 -translate-y-1/4 sm:translate-x-0 lg:size-[400%]">
            <Image
              fill
              priority
              alt=""
              className="hidden object-contain sm:block"
              src={images.shape}
            />
          </div>
        </div>

        <div className="absolute inset-0 z-30 flex items-center justify-center px-4 md:px-20">
          <div className="mx-auto w-full max-w-screen-2xl">
            <h1 className="font-secondary text-balance text-4xl font-normal text-white md:text-7xl">
              {t('title')}
            </h1>
            <h2 className="font-primary text-md mb-10 mt-6 text-balance font-semibold text-white md:max-w-[70%] md:text-lg">
              {t.rich('subtitle', {
                ref: (chunks) => (
                  <a
                    className="cursor-pointer align-super text-[0.6em] underline"
                    href="#hero-footnote"
                  >
                    {chunks}
                  </a>
                ),
              })}
            </h2>
            <Button
              className="bg-white text-primary hover:bg-gray-50"
              onClick={scrollToContactCard}
            >
              {t('cta')}
            </Button>
          </div>
        </div>
        <p
          className="absolute bottom-4 left-4 z-30 hidden text-xs text-white/70 md:left-20 md:block"
          id="hero-footnote"
        >
          {footnote}
        </p>
      </section>
      <p className="px-4 py-2 text-xs text-muted-foreground md:hidden">
        {footnote}
      </p>
    </>
  );
};
